import { useLocation, useNavigate } from 'react-router-dom'
import { appUrl } from '@astro/config'

export default function OrderConfirmed() {
  const navigate = useNavigate()
  // Passed by the checkout flow after payment verification succeeds.
  const orderId = useLocation().state?.orderId ?? null

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6 pt-28 pb-16 font-normal uppercase select-none">
      <div className="max-w-2xl w-full text-center space-y-8">
        {/* Check icon on a soft amber halo */}
        <div className="relative mx-auto w-40 h-40">
          <div className="absolute inset-0 rounded-full bg-[radial-gradient(circle,rgba(242,160,7,0.18),transparent_70%)] blur-xl"></div>
          <div className="absolute inset-6 rounded-full bg-secondary/10"></div>
          <div className="absolute inset-0 grid place-items-center">
            <div className="w-16 h-16 rounded-full border-[3px] border-secondary grid place-items-center text-secondary bg-background">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <p className="text-[10px] font-mono font-normal text-secondary uppercase tracking-[0.5em]">
            TRANSACTION SYNCHRONIZED
          </p>
          <h1 className="font-heading text-4xl md:text-6xl text-primary font-normal uppercase leading-tight">
            DIVINE ORDER CONFIRMED
          </h1>

          {/* Highlighted order reference */}
          {orderId && (
            <div className="pt-2">
              <span className="inline-flex items-center gap-3 px-6 py-2.5 rounded-full border border-secondary/40 bg-secondary/10">
                <span className="h-1.5 w-1.5 rounded-full bg-secondary animate-pulse"></span>
                <span className="text-[10px] font-mono font-normal text-primary/50 uppercase tracking-[0.25em]">ORDER ID</span>
                <span className="text-sm font-mono font-semibold text-secondary tracking-widest">#{orderId}</span>
              </span>
            </div>
          )}

          <p className="mx-auto max-w-md text-base md:text-lg text-primary/70 font-body normal-case leading-relaxed">
            your spiritual remedies are being prepared for high-precision
            energization and dispatch from the mission point.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
          {/* With the order number in hand, land directly on its live tracking
              page; otherwise fall back to the website dashboard's order history
              (cross-app link — the dashboard lives in the website app). */}
          <button
            type="button"
            onClick={() =>
              orderId
                ? navigate(`/orders/${encodeURIComponent(orderId)}`)
                : window.location.assign(appUrl('website', '/dashboard?tab=orders'))
            }
            className="group inline-flex items-center justify-center gap-3 h-14 px-10 rounded-lg bg-primary text-white hover:bg-secondary transition-all duration-300 font-semibold uppercase tracking-[0.2em] text-[11px] shadow-lg shadow-primary/20 active:scale-95"
          >
            {orderId ? 'TRACK THIS ORDER' : 'TRACK ORDER HISTORY'}
            <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
          </button>
          <button
            type="button"
            onClick={() => navigate('/products')}
            className="inline-flex items-center justify-center h-14 px-10 rounded-lg border border-primary/25 text-primary hover:border-secondary hover:text-secondary transition-all duration-300 font-semibold uppercase tracking-[0.2em] text-[11px] active:scale-95"
          >
            CONTINUE SHOPPING
          </button>
        </div>
      </div>
    </div>
  )
}
